import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
`;

export const StackedElements = styled.div``;
